import styled from 'styled-components';

export default styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;
`;



// WEBPACK FOOTER //
// ./src/components/formElements/StyledInputRow.tsx